"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _keycode = _interopRequireDefault(require("keycode"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _reactEventListener = _interopRequireDefault(require("react-event-listener"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withWidth = _interopRequireWildcard(require("@material-ui/core/withWidth"));

var _Input = _interopRequireDefault(require("@material-ui/core/Input"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _styles = require("@material-ui/core/styles");

var searchTimer;
var initialized = false;

function initDocsearch() {
  if (!process.browser) {
    return;
  }

  clearInterval(searchTimer);
  searchTimer = setInterval(function () {
    var docsearchInput = document.querySelector('#docsearch-input');

    if (!window || !window.docsearch || !docsearchInput) {
      return;
    }

    if (initialized === docsearchInput) {
      clearInterval(searchTimer);
      return;
    }

    initialized = docsearchInput;
    clearInterval(searchTimer);
    var client = algoliasearch('YJ8DQBD87H', '6ce03b6d7b23403fbb92d35c902073c5');
    var index = client.initIndex('6star-');
    window.docsearch({
      appId: 'YJ8DQBD87H',
      apiKey: '6ce03b6d7b23403fbb92d35c902073c5',
      indexName: 'docs-',
      inputSelector: '#docsearch-input',
      handleSelected: function handleSelected(input, event, suggestion) {
        var url = suggestion.url.replace(/^https:\/\/nifty-jepsen-a1a20b\.netlify\.com/, '').replace(/\/#/, '#').replace(/\/$/, '');
      },
      // Set debug to true if you want to inspect the dropdown.
      debug: false
    });
  }, 100);
}

var styles = function styles(theme) {
  return {
    '@global': {
      '.algolia-autocomplete': {
        fontFamily: theme.typography.fontFamily,
        '& .algolia-docsearch-suggestion--category-header-lvl0': {
          color: theme.palette.text.primary
        },
        '& .algolia-docsearch-suggestion .algolia-docsearch-suggestion--subcategory-column': {
          opacity: 1,
          padding: '5.33px 10.66px',
          textAlign: 'right',
          width: '30%',
          '&:before': {
            display: 'block'
          },
          '&:after': {
            display: 'none'
          }
        },
        '& .algolia-docsearch-suggestion .algolia-docsearch-suggestion--content': {
          float: 'right',
          padding: '5.33px 0 5.33px 10.66px',
          width: '70%',
          '&:before': {
            display: 'block'
          }
        },
        '& .algolia-docsearch-suggestion--subcategory-column-text': {
          color: theme.palette.text.secondary,
          fontWeight: theme.typography.fontWeightRegular
        },
        '& .algolia-docsearch-suggestion--highlight': {
          color: theme.palette.type === 'light' ? '#174d8c' : '#acccf1'
        },
        '& .algolia-docsearch-suggestion': {
          background: 'transparent'
        },
        '& .algolia-docsearch-suggestion--title': (0, _extends2.default)({}, theme.typography.title),
        '& .algolia-docsearch-suggestion--text': (0, _extends2.default)({}, theme.typography.body1),
        '& .ds-dropdown-menu': {
          boxShadow: theme.shadows[1],
          borderRadius: 2,
          '&::before': {
            display: 'none'
          },
          '& [class^=ds-dataset-]': {
            border: 0,
            borderRadius: 2,
            backgroundColor: theme.palette.background.paper
          }
        }
      }
    },
    root: {
      fontFamily: theme.typography.fontFamily,
      position: 'relative',
      marginRight: theme.spacing.unit * 2,
      marginLeft: theme.spacing.unit,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.common.white, 0.25)
      },
      '& $inputInput': {
        transition: theme.transitions.create('width'),
        width: 120,
        '&:focus': {
          width: 170
        }
      }
    },
    search: {
      width: theme.spacing.unit * 9,
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    inputRoot: {
      color: 'inherit'
    },
    inputInput: {
      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit, "px ").concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 9, "px")
    }
  };
};

var _ref = _react.default.createElement(_Search.default, null);

var AppSearch =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(AppSearch, _React$Component);

  function AppSearch() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AppSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AppSearch)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.inputRef = null;

    _this.handleKeyDown = function (event) {
      if (['/', 's'].indexOf((0, _keycode.default)(event)) !== -1 && document.activeElement.nodeName.toLowerCase() === 'body' && document.activeElement !== _this.inputRef) {
        event.preventDefault();

        _this.inputRef.focus();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(AppSearch, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          width = _this$props.width;

      if ((0, _withWidth.isWidthUp)('sm', width)) {
        initDocsearch();
      }

      return _react.default.createElement("div", {
        className: classes.root,
        style: {
          display: (0, _withWidth.isWidthUp)('sm', width) ? 'block' : 'none'
        }
      }, _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onKeyDown: this.handleKeyDown
      }), _react.default.createElement("div", {
        className: classes.search
      }, _ref), _react.default.createElement(_Input.default, {
        disableUnderline: true,
        placeholder: "Search Docs\u2026",
        id: "docsearch-input",
        inputRef: function inputRef(ref) {
          _this2.inputRef = ref;
        },
        classes: {
          root: classes.inputRoot,
          input: classes.inputInput,
          aa_input_search: classes.aa_input_search
        }
      }));
    }
  }]);
  return AppSearch;
}(_react.default.Component);

AppSearch.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes.default.object.isRequired,
  width: _propTypes.default.string.isRequired
} : {};

var _default = (0, _compose.default)((0, _styles.withStyles)(styles), (0, _withWidth.default)())(AppSearch);

exports.default = _default;